import React from 'react';
import { formatDdMmYyyy } from '../utils/formatDdMmYyyy';
import { NOT_PROVIDED_TEXT, NOT_APPLICABLE_TEXT } from '../utils/gapReportDraft';

/**
 * One non-derived section of the Gap Analysis report draft. Empty is shown as "Not provided" (never
 * invented prose). When `canConfirm` (Advisor, Draft status) the Advisor confirms the text or marks it
 * not applicable; saving the draft requires one or the other for every section the data did not supply
 * (utils/gapReportDraft.js). Native inputs only: this renders inside the report document.
 */
const GapReportSectionField = ({ fieldKey, label, value, status, origin, editing, canConfirm, inputType = 'text', onChange, onStatus }) => {
  const text = typeof value === 'string' ? value : '';
  const isNa = status === 'na';
  const derived = origin === 'derived' && text.trim() !== '';
  const inputStyle = 'w-full border rounded-lg p-2 text-sm mt-1 outline-none focus:ring-2 focus:ring-blue-500/20';
  return (
    <div data-testid={`report-field-${fieldKey}`}>
      <strong className="text-xs uppercase text-slate-500">{label}:</strong>
      {editing && !isNa ? (
        <input
          type={inputType}
          value={text}
          placeholder={inputType === 'date' ? undefined : NOT_PROVIDED_TEXT}
          onChange={(e) => onChange(fieldKey, e.target.value)}
          className={inputStyle}
          aria-label={label}
        />
      ) : isNa ? (
        <p className="text-sm text-slate-500 italic mt-1" data-testid={`report-field-${fieldKey}-na`}>{NOT_APPLICABLE_TEXT}</p>
      ) : text.trim() ? (
        <p className="text-sm text-slate-700 mt-1">{inputType === 'date' ? formatDdMmYyyy(text) : text}</p>
      ) : (
        <p className="text-sm text-amber-700 italic mt-1" data-testid={`report-field-${fieldKey}-empty`}>{NOT_PROVIDED_TEXT}</p>
      )}
      {derived && <p className="text-[10px] text-slate-400 mt-1">From the company profile.</p>}
      {canConfirm && (
        <div className="flex flex-wrap gap-4 mt-1 text-xs text-slate-600">
          {!derived && text.trim() !== '' && !isNa && (
            <label className="inline-flex items-center gap-1">
              <input
                type="checkbox"
                checked={status === 'confirmed'}
                onChange={(e) => onStatus(fieldKey, e.target.checked ? 'confirmed' : null)}
                data-testid={`report-field-${fieldKey}-confirm`}
              />
              I have checked this section
            </label>
          )}
          <label className="inline-flex items-center gap-1">
            <input
              type="checkbox"
              checked={isNa}
              onChange={(e) => onStatus(fieldKey, e.target.checked ? 'na' : null)}
              data-testid={`report-field-${fieldKey}-na-toggle`}
            />
            Not applicable
          </label>
        </div>
      )}
    </div>
  );
};

export default GapReportSectionField;
